export default {
  'tracking:page-title': 'Verzending volgen',
  'tracking:title': 'Zendingtracering',
  'tracking:status:1': '1. Je bestelling in de webshop is geslaagd',
  'tracking:status:2':
    '2. {employee} is op dit moment in ons verzendmagazijn met je bestelling bezig',
  'tracking:status:3':
    '3. Je bestelling is klaar voor verzending. Zodra het verzendbedrijf je pakket heeft ontvangen, ontvang je hieronder gedetailleerde informatie over het verdere verloop van je zending:',
};
